<template>
  <div style="height: 100vh; width: 100vw; overflow: hidden">
    <!-- <div class="scroll-progress primary-bg"></div> -->

    <!-- header -->
    <Header :isHome="false"></Header>

    <!-- <div style="position: fixed;left: 0;top: 0;width: 100vw;height: 100vh;background-color: rgba(0, 0, 0, 0.9);z-index: 9999;align-items: center;justify-content: center;display: flex;"> -->
    <div style="" class="login-box">
      <div class="login">
        <!-- beforelogin -->
        <div v-show="step == 0">
          <div class="login-title" style="text-align: start">Log In GCI</div>

          <div
            style="
              display: flex;
              align-items: center;
              justify-content: center;
              margin-top: 2rem;
            "
          >
            <div class="g_id_signin" id="g_id_signin" style="width: 100%"></div>
          </div>
          <div
            style="
              display: flex;
              flex-direction: column;
              justify-content: center;
              width: 20rem;
              margin-top: 1rem;
            "
            v-show="googleload"
          >
            <div
              style="
                display: flex;
                align-items: center;
                justify-content: center;
              "
            >
              <div
                style="height: 1px; width: 10rem; background-color: #eee"
              ></div>
              <span
                style="
                  font-size: 0.5rem;
                  color: #06413c;
                  display: flex;
                  justify-content: center;
                  margin: 0 0.5rem;
                  color: #000;
                  font-weight: bold;
                "
                class="login-agreement"
                >OR</span
              >
              <div
                style="height: 1px; width: 10rem; background-color: #eee"
              ></div>
            </div>
          </div>
          <div style="" class="login-input-box">
            <span class="login-input-box-text">Email or username</span>
            <input
              type="text"
              class="login-input"
              placeholder="Email or username"
              v-model="username"
            />
          </div>
          <div
            style="
              margin-top: 1rem;
              display: flex;
              align-items: center;
              justify-content: center;
              flex-direction: column;
            "
          >
            <div
              class="login-button"
              @click="step = 1"
              style="cursor: pointer; width: 100%; border-radius: 1.5rem"
            >
              Next Step
            </div>
            <div
              class="login-button"
              @click="step = 3"
              style="
                cursor: pointer;
                width: 100%;
                border-radius: 1.5rem;
                background: #fff;
                margin-top: 1rem;
                border: 1px solid #eee;
              "
            >
              Forgot your password?
            </div>
          </div>
          <div style="margin-top: 2rem">
            No account yet ?
            <span
              style="
                color: #0e6058;
                text-decoration: underline;
                font-weight: bold;
              "
              @click="toregister"
              >Register</span
            >
          </div>
        </div>

        <!-- beforeregister -->
        <div v-show="step == 5">
          <div class="login-title" style="text-align: start">Log In GCI</div>

          <div
            style="
              display: flex;
              align-items: center;
              justify-content: center;
              margin-top: 2rem;
            "
          >
            <div class="g_id_signin" id="g_id_signin" style="width: 100%"></div>
          </div>
          <div
            style="
              display: flex;
              flex-direction: column;
              justify-content: center;
              width: 20rem;
              margin-top: 1rem;
            "
            v-show="googleload"
          >
            <div
              style="
                display: flex;
                align-items: center;
                justify-content: center;
              "
            >
              <div
                style="height: 1px; width: 10rem; background-color: #eee"
              ></div>
              <span
                style="
                  font-size: 0.5rem;
                  color: #06413c;
                  display: flex;
                  justify-content: center;
                  margin: 0 0.5rem;
                  color: #000;
                  font-weight: bold;
                "
                class="login-agreement"
                >OR</span
              >
              <div
                style="height: 1px; width: 10rem; background-color: #eee"
              ></div>
            </div>
          </div>
          <div
            style="
              margin-top: 1rem;
              display: flex;
              align-items: center;
              justify-content: center;
              flex-direction: column;
            "
          >
            <div
              class="login-button"
              @click="step = 2"
              style="cursor: pointer; width: 100%; border-radius: 1.5rem"
            >
              Create an account
            </div>
          </div>
          <div style="margin-top: 2rem">
            I already have an account
            <span
              style="color: #0e6058; text-decoration: underline"
              @click="step = 1"
              >Log on</span
            >
          </div>
        </div>
        <!-- afterforget -->
        <div
          v-show="step == 6"
          v-if="email"
          style="
            padding: 0 1rem;
            display: flex;
            align-items: center;
            flex-direction: column;
          "
        >
          <img
            src="../../assets/imgs/login/login-success.png"
            style="width: 3rem; height: 3rem; margin-bottom: 1rem"
          />
          <div class="firstlogin-title">Successfull!</div>
          <div class="firstlogin-desc">Send an email to {{ email }}</div>
          <!-- <div class="login-title" style="text-align: start;">Successfully！</div> -->

          <!-- <div class="login-input-box" style="margin-top: 1rem;"><span class="login-input-box-text">Send an email to {{email}}</span></div> -->

          <!-- <div style="color: #333;font-size: 1rem;margin-top: 2rem;display: flex;align-items: center;">
							<span style="flex: 1;">Send an email to {{email.slice(0,2)||''}}******@{{email.split('@')[1].slice(0,1)}}***</span>
							<img src="../../assets/imgs/login/checked.svg" style="width: 1rem;height: 1rem">
						</div> -->
          <div
            style="
              color: #999;
              margin-top: 1rem;
              font-size: 0.8rem;
              text-align: center;
            "
          >
            The link to change the password has been sent to your email. Please
            move to the email to change the password
          </div>
          <!-- <div style="margin-top: 1rem;display: flex;align-items: center;justify-content: center;flex-direction: column;">
							<div class="login-button" @click="step=2" style="cursor: pointer;width: 100%;border-radius: 1.5rem;">
								Next Step
							</div>
						</div> -->
        </div>
        <!-- login -->
        <div v-show="step == 1">
          <div class="login-title">Enter your password</div>
          <div class="error-text" :class="{ error: errorshow }">
            Please Checked User Agreement!
          </div>
          <div style="" class="login-input-box">
            <span class="login-input-box-text">Email or username</span>
            <input
              type="text"
              class="login-input"
              placeholder="Email or username"
              v-model="username"
            />
          </div>
          <div style="margin-top: 0.5rem" class="login-input-box">
            <div style="display: flex">
              <span class="login-input-box-text" style="flex: 1">Password</span>
              <div
                style="
                  color: #0e6058;
                  font-size: 0.7rem;
                  display: flex;
                  align-items: center;
                  justify-content: center;
                  cursor: pointer;
                "
                class="login-agreement"
                @click="toforget"
              >
                Forgot your password?
              </div>
            </div>
            <input
              type="password"
              class="login-input"
              placeholder="Password"
              v-model="password"
            />
          </div>
          <div
            style="
              margin-top: 1rem;
              display: flex;
              align-items: center;
              color: #000;
              font-size: 0.5rem;
            "
            class="login-agreement"
          >
            <div style="flex: 1; display: flex; align-items: center">
              <img
                :src="
                  checkactive
                    ? require('../../assets/imgs/login/checked.svg')
                    : require('../../assets/imgs/login/check.svg')
                "
                class="check"
                @click="checkactive = !checkactive"
              />
              <span style="color: #333"
                >Please Checked
                <span
                  style="
                    color: #0e6058;
                    text-decoration: underline;
                    cursor: pointer;
                  "
                  @click="toagreement"
                  >User Agreement!</span
                ></span
              >
            </div>
            <!-- <span style="cursor: pointer;font-weight: bold;text-decoration: underline;" @click="toregister">Sign up</span> -->
          </div>
          <div
            style="
              margin-top: 2rem;
              display: flex;
              align-items: center;
              justify-content: center;
            "
          >
            <!-- <div class="login-button" @click="login()" style="cursor: pointer;">
								Log in now
							</div> -->

            <div
              class="login-button"
              @click="login()"
              style="cursor: pointer; width: 100%; border-radius: 1.5rem"
            >
              Log in now
            </div>
          </div>

          <div style="margin-top: 1rem">
            No account yet ?
            <span
              style="
                color: #0e6058;
                text-decoration: underline;
                font-weight: bold;
              "
              @click="step = 5"
              >Register</span
            >
          </div>
        </div>

        <!-- register -->
        <div v-show="step == 2">
          <div class="login-title">Create your account</div>
          <div class="error-text" :class="{ error: errorshow }">
            Please Checked User Agreement!
          </div>
          <div style="" class="login-input-box">
            <span class="login-input-box-text">Username(*)</span>
            <input
              type="text"
              class="login-input"
              placeholder="Username"
              v-model="username"
            />
          </div>
          <div style="" class="login-input-box">
            <span class="login-input-box-text">Email(*)</span>
            <input
              type="text"
              class="login-input"
              placeholder="Email"
              v-model="email"
              :disabled="isthreepart"
            />
          </div>
          <div style="" class="login-input-box" v-if="!isthreepart">
            <span class="login-input-box-text">Code</span>
            <div style="display: flex; align-items: center">
              <input
                type="text"
                class="login-input"
                placeholder="Verivication Code"
                v-model="code"
                style="
                  margin-top: 0;
                  border-radius: 0.2rem 0 0 0.2rem;
                  width: 12rem;
                "
              />
              <div
                class="login-button"
                @click="sendemail()"
                style="
                  width: 8rem;
                  border-radius: 0 0.2rem 0.2rem 0;
                  cursor: pointer;
                  font-size: 0.9rem;
                "
                v-if="!istime"
              >
                Get code
              </div>
              <div
                class="login-button"
                style="width: 8rem; border-radius: 0 0.2rem 0.2rem 0"
                v-if="istime"
              >
                {{ timer }}s
              </div>
            </div>
          </div>
          <div style="" class="login-input-box">
            <span class="login-input-box-text">Password(*)</span>
            <input
              type="password"
              class="login-input"
              placeholder="More than 6 digits in English + numbers"
              v-model="password"
            />
          </div>
          <div
            style="
              margin-top: 1rem;
              display: flex;
              align-items: center;
              color: #06413c;
              font-size: 0.5rem;
            "
          >
            <div style="flex: 1; display: flex; align-items: flex-start">
              <img
                :src="
                  agreeactive
                    ? require('../../assets/imgs/login/checked.svg')
                    : require('../../assets/imgs/login/check.svg')
                "
                class="check"
                @click="agreeactive = !agreeactive"
              />
              <span style="width: 18rem; color: #333" class="login-agreement"
                >I agree to terms of use, privacy policy, IPR and agree to
                receive emails related to
                <span
                  style="
                    text-decoration: underline;
                    color: #0e6058;
                    font-weight: bold;
                    cursor: pointer;
                  "
                  @click="toagreement"
                  >our services.</span
                ></span
              >
            </div>

            <!-- <span style="margin-left: 3rem;text-decoration: underline">Register</span> -->
          </div>
          <div
            style="
              margin-top: 1rem;
              display: flex;
              align-items: center;
              justify-content: center;
            "
          >
            <!-- <div class="login-button" @click="register()" style="cursor: pointer;">
								Sign up
							</div> -->
            <div
              class="login-button"
              @click="register()"
              style="cursor: pointer; width: 100%; border-radius: 1.5rem"
            >
              Log in now
            </div>
          </div>
          <div style="margin-top: 1rem">
            I already have an account
            <span
              style="
                color: #0e6058;
                text-decoration: underline;
                font-weight: bold;
              "
              @click="step = 0"
              >Log on</span
            >
          </div>
          <!-- <div style="position: absolute;left: 1rem;top: 1rem;font-size: 1rem;color: #999;cursor: pointer;" @click="step=1">
							<div>back</div>
						</div> -->
        </div>

        <!-- froget -->
        <div v-show="step == 3" style="width: 20rem">
          <div class="login-title">Find your GCI account</div>
          <div class="login-input-box" style="margin-top: 1rem">
            <span class="login-input-box-text"
              >Enter your email address and we will send you a link to reset
              your password.</span
            >
          </div>
          <div style="" class="login-input-box">
            <span class="login-input-box-text">Email(*)</span>
            <input
              type="text"
              class="login-input"
              placeholder="Email"
              v-model="email"
            />
          </div>
          <div v-if="emailnotexist" style="margin-top: 1rem">
            This email is not registered. Please click
            <span
              style="
                text-decoration: underline;
                color: #0e6058;
                cursor: pointer;
              "
              @click="step = 2"
              >Register</span
            >
          </div>
          <div
            style="
              margin-top: 1rem;
              display: flex;
              align-items: center;
              justify-content: center;
            "
          >
            <div
              class="login-button"
              @click="forgetsubmit()"
              style="cursor: pointer; width: 100%; border-radius: 1.5rem"
            >
              Next Step
            </div>
          </div>
        </div>
      </div>
      <div style="position: absolute; right: 2rem; top: 1rem" @click="close">
        <img src="../../assets/imgs/login/close.svg" class="close" />
      </div>
    </div>
    <!-- </div> -->

    <!-- footer -->
    <!-- <Footer></Footer> -->
  </div>
</template>

<script>
import Header from "/src/components/header.vue";
import Footer from "/src/components/footer.vue";
import jwt_decode from "jwt-decode";
import md5 from "js-md5";
import loadJs from "../../assets/js/loadJs.js";
export default {
  data() {
    return {
      step: 0,
      checkactive: false,
      agreeactive: false,
      errorshow: false,

      GOOGLE_CLIENT_ID:
        "157481512576-nlfq81oj6a16t1a1av76rbqrbjvlfjkv.apps.googleusercontent.com",

      username: "",
      password: "",
      email: "",
      code: "",
      threepartdata: null,
      nationdata: null,
      nation: "",
      nationid: "",
      industrydata: null,
      industry: "",
      tagsdata: null,
      tags: [],

      istime: false,
      timer: 60,
      isthreepart: false,

      nationbox: 0,
      tagsbox: 0,
      emailnotexist: false,

      googleload: false,
    };
  },
  components: {
    Header,
    Footer,
  },
  filters: {},
  methods: {
    toregister() {
      this.step = 5;
      this.googleinit();
    },
    login() {
      if (this.username == "") {
        this.$bus.$emit("message", {
          type: 1,
          msg: "Please enter login account",
        });
      } else if (this.password == "") {
        this.$bus.$emit("message", {
          type: 1,
          msg: "Please enter password",
        });
      } else if (!this.checkactive) {
        this.$bus.$emit("message", {
          type: 1,
          msg: "Please Checked User Agreement!",
        });
      } else {
        let params = {
          username: this.username,
          password: md5(this.password),
        };
        this.request({
          method: "post",
          url: "/gci/auth/login",
          data: params,
        })
          .then((res) => {
            if (res.status == 1000) {
              this.$bus.$emit("message", {
                type: 3,
                msg: res.msg,
              });
            }
            if (res.status == 0) {
              console.info("token", res.data.token);
              localStorage.setItem("token", res.data.token);
              localStorage.setItem("user", JSON.stringify(res.data.user));
              console.log(this.$route.query.redirect);
              // if(this.$route.query.redirect){
              // 	window.location.replace(this.$route.query.redirect)
              // }else{
              this.$router.push({ name: "home" });
              // }

              location.reload();
            }
          })
          .catch((error) => {
            console.error(error.response);
          });
      }
    },
    sendemail() {
      if (this.email == "") {
        this.$bus.$emit("message", {
          type: 1,
          msg: "Please enter registered email",
        });
      } else {
        if (!this.istime) {
          this.request({
            method: "get",
            url: "/gci/auth/register/verify?email=" + this.email,
          })
            .then((res) => {
              if (res.status == 0) {
                this.timer = 60;
                this.istime = true;
                let that = this;
                let t = setInterval(() => {
                  if (that.timer > 0) {
                    that.timer--;
                  } else {
                    that.istime = false;
                    clearInterval(t);
                  }
                }, 1000);
              } else {
                this.$bus.$emit("message", {
                  type: 3,
                  msg: res.msg,
                });
              }
            })
            .catch((error) => {
              console.error(error.response);
            });
        }
      }
    },
    register() {
      let pwdReg = /^(?=.*[A-Za-z])(?=.*\d)[A-Za-z\d]{6,}$/;
      if (this.username == "") {
        this.$bus.$emit("message", {
          type: 1,
          msg: "Please enter registered username",
        });
      } else if (this.email == "") {
        this.$bus.$emit("message", {
          type: 1,
          msg: "Please enter registered email",
        });
      } else if (this.password == "") {
        this.$bus.$emit("message", {
          type: 1,
          msg: "Please enter registered password",
        });
      } else if (!pwdReg.test(this.password)) {
        this.$bus.$emit("message", {
          type: 1,
          msg: "Passwords must contain letters and numbers and have a length greater than 6",
        });
      } else if (!this.agreeactive) {
        this.$bus.$emit("message", {
          type: 1,
          msg: "Please Checked User Agreement!",
        });
      } else {
        if (this.isthreepart) {
          let params = {
            username: this.username,
            password: md5(this.password),
            email: this.email,
          };
          this.request({
            method: "post",
            url: "/gci/auth/registerThird",
            data: params,
          })
            .then((res) => {
              if (res.status == 0) {
                // localStorage.setItem('token', res.data.token)
                // this.$router.push({name:'home'})
                // location.reload();
                this.request({
                  method: "post",
                  url: "/gci/auth/login",
                  data: params,
                })
                  .then((res) => {
                    if (res.status == 1000) {
                      this.$bus.$emit("message", {
                        type: 3,
                        msg: res.msg,
                      });
                    }
                    if (res.status == 0) {
                      console.info("token", res.data.token);
                      localStorage.setItem("token", res.data.token);
                      localStorage.setItem(
                        "user",
                        JSON.stringify(res.data.user)
                      );
                      this.$router.push({ name: "home" });
                      location.reload();
                    }
                  })
                  .catch((error) => {
                    console.error(error.response);
                  });
              } else {
                this.$bus.$emit("message", {
                  type: 3,
                  msg: res.msg,
                });
              }
            })
            .catch((error) => {
              console.error(error.response);
            });
        } else {
          if (this.code == "") {
            this.$bus.$emit("message", {
              type: 1,
              msg: "Please enter code",
            });
          } else {
            let params = {
              username: this.username,
              password: md5(this.password),
              code: this.code,
              email: this.email,
            };
            this.request({
              method: "post",
              url: "/gci/auth/register",
              data: params,
            })
              .then((res) => {
                if (res.status == 0) {
                  // localStorage.setItem('token', res.data.token)
                  // this.$router.push({name:'home'})
                  // location.reload();
                  this.request({
                    method: "post",
                    url: "/gci/auth/login",
                    data: params,
                  })
                    .then((res) => {
                      if (res.status == 1000) {
                        this.$bus.$emit("message", {
                          type: 3,
                          msg: res.msg,
                        });
                      }
                      if (res.status == 0) {
                        console.info("token", res.data.token);
                        localStorage.setItem("token", res.data.token);
                        localStorage.setItem(
                          "user",
                          JSON.stringify(res.data.user)
                        );
                        this.$router.push({ name: "home" });
                        location.reload();
                      }
                    })
                    .catch((error) => {
                      console.error(error.response);
                    });
                } else {
                  this.$bus.$emit("message", {
                    type: 3,
                    msg: res.msg,
                  });
                }
              })
              .catch((error) => {
                console.error(error.response);
              });
          }
        }
      }
    },
    forgetsubmit() {
      if (this.email == "") {
        this.$bus.$emit("message", {
          type: 1,
          msg: "please enter your email",
        });
      } else {
        this.request({
          method: "get",
          url: "/gci/auth/forget/verify?email=" + this.email,
        })
          .then((res) => {
            if (res.status == 0) {
              this.step = 6;
            }
            if (res.status == 1000) {
              this.emailnotexist = true;
            }
          })
          .catch((error) => {
            console.error(error.response);
          });
      }
    },
    toforget() {
      this.step = 3;
    },
    prestep() {
      this.step = 1;
    },
    googlelogin() {},
    async handleCredentialResponse(response) {
      // 获取回调响应的凭证数据 然后拿这个凭证给后台，jwt进行解析获取登录信息
      console.info(response);
      this.isthreepart = true;
      // await api.googleLogin(code);
      const profile = jwt_decode(response.credential); // 解析返回的信息
      // id = profile.sub; email = profile.email;  需要什么取什么，然后传给后端验证
      console.log("GOOGLE response:", profile);
      this.threepartdata = profile;
      this.email = profile.email;
      // this.step = 2

      let params = {
        credential: response.credential,
      };
      this.request({
        method: "post",
        url: "/gci/auth/loginThird",
        data: params,
      })
        .then((res) => {
          if (!res.data.registered) {
            this.step = 2;
          } else {
            localStorage.setItem("token", res.data.token);
            localStorage.setItem("user", JSON.stringify(res.data.user));
            this.$router.push({ name: "home" });
            location.reload();
          }
        })
        .catch((error) => {
          console.error(error.response);
        });
    },
    close() {
      this.$router.go(-1);
    },
    toagreement() {
      let routeUrl = this.$router.resolve({
        name: "agreement",
      });
      window.open(routeUrl.href, "_blank");
    },
    googleinit() {
      loadJs("https://accounts.google.com/gsi/client?hl=en").then(() => {
        // window.addEventListener('load', () => {
        window.google.accounts.id.initialize({
          // 主要就是填写client_id
          client_id: this.GOOGLE_CLIENT_ID,
          auto_select: false,
          callback: this.handleCredentialResponse,
        });
        // 设置按钮的样式等
        window.google.accounts.id.renderButton(
          document.getElementById("g_id_signin"),
          {
            theme: "filled_white",
            size: "large",
            // width:'320',
            type: "standard",
            text: "signin_with",
          }
        );
        this.googleload = true;
        // })
      });
    },
  },
  mounted() {
    this.step = this.$route.query.type;
    // this.getnationdata()
    // this.gettagsdata()
    this.googleinit();
    this.$bus.$emit("totopshow", false);
    this.$bus.$emit("tologinbtn", false);
  },
};
</script>

<style scoped lang="scss">
.firstlogin-title {
  font-size: 1.5rem;
  font-weight: bold;
  margin-bottom: 1rem;
}
.firstlogin-desc {
  font-size: 1rem;
  text-align: center;
  font-weight: 500;
}
.sel-box {
  width: 20rem;
  height: 30rem;
  position: absolute;
  background-color: #fff;
  border: 1px solid #000;
  left: 0;
  top: 4.5rem;
  overflow: scroll;
  z-index: 20;
  .sel-box-list {
    display: flex;
    padding: 0 1rem;
  }
}
.sel-box-list:hover {
  background-color: #31ffda;
}
.sel-box::-webkit-scrollbar {
  display: none;
}
.error-text {
  color: #ff0000;
  font-size: 0.7rem;
  margin-top: 1rem;
  opacity: 0;
}
.error {
  opacity: 1;
}
.threepart-btn-img {
  width: 1rem;
  height: 1rem;
  margin-right: 0.2rem;
}
.threepart-btn {
  border: 1px solid #c5c5c5;
  border-radius: 0.2rem;
  display: flex;
  align-items: center;
  justify-content: center;
  margin-top: 0.5rem;
  width: 7rem;
  height: 2rem;
}
.login-button {
  background: linear-gradient(90deg, #4edfd2 0%, #92fbf2 100%);
  border-radius: 0.2rem;
  color: #333;
  font-size: 1rem;
  font-weight: bold;
  width: 12rem;
  height: 2.5rem;
  display: flex;
  align-items: center;
  justify-content: center;
}
.check {
  // border: 1px solid #0E6058;
  width: 1rem;
  height: 1rem;
  margin-right: 0.3rem;
}
.check-active {
}
.login-box {
  display: flex;
  border-radius: 1rem;
  overflow: hidden;
  position: relative;
  margin-top: 5rem;
  .login {
    width: 25rem;
    height: 35rem;
    background-color: #fff;
    display: flex;
    justify-content: center;
    padding-top: 10rem;
    .login-title {
      font-size: 1.5rem;
      color: #333;
      font-weight: bold;
    }
    .login-input-box {
      margin-top: 1rem !important;
      display: flex;
      flex-direction: column;
      .login-input-box-text {
        color: #333;
        font-weight: 500;
        font-size: 0.9rem;
      }
      .login-input {
        border: 1px solid #eee;
        padding: 0.5rem;
        margin-top: 0.5rem;
        border-radius: 0.2rem;
        width: 20rem;
        font-size: 0.7rem;
      }
    }
  }
  .login-r {
    background-image: url("../../assets/imgs/login/login-r.png");
    width: 20rem;
    height: 35rem;
    background-size: cover;
    background-repeat: no-repeat;
    background-position: center center;
    display: flex;
    align-items: center;
    justify-content: center;
    flex-direction: column;
  }
}

.login-input:hover {
  border: 1px solid #000 !important;
}
.close {
  width: 1.2rem;
  height: 1.2rem;
  opacity: 1;
}
input::placeholder {
  color: #ccc;
  font-weight: 400 !important;
}
@media (max-width: 767px) {
  .login-r {
    display: none !important;
  }
  .login-box {
    border-radius: 0 !important;
  }
  .login {
    height: 100vh !important;
    width: 100vw !important;
  }
  .login-agreement {
    font-size: 0.9rem !important;
  }
  .login-input {
    font-size: 0.9rem !important;
  }
  .login-title {
    margin-top: -5rem;
  }
}
</style>
